export function emptyPersistedState() {
    return { lastSeenOutboxId: null, channels: [], trackedJobIds: [], offlineQueue: [] };
}
export function createMemoryClientPersistence() {
    let state = emptyPersistedState();
    return {
        load: () => state,
        save: (next) => {
            state = next;
        },
    };
}
